/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BusinessSettingsModalComponent} from './business-settings-modal.component';
import {GenericModalModule} from '../../../../shared/generic-modal/generic-modal.module';
import {InputModule} from '../../../../shared/input/input.module';

@NgModule({
    declarations: [BusinessSettingsModalComponent],
    imports: [
        CommonModule,
        InputModule,
        GenericModalModule
    ],
    exports: [BusinessSettingsModalComponent]

})
export class BusinessSettingsModalModule {
}
